import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from '../auth/not-found/not-found.component';
import { GenerateTokenComponent } from './generateToken/generateToken.component';
import { ChangePasswordComponent } from './changePassword/changePassword.component';

const resetPasswordRoutes: Routes = [
  {
    path: '',
    component: GenerateTokenComponent,
  },
  {
    path: ':token',
    component: ChangePasswordComponent,
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(resetPasswordRoutes)],
  exports: [RouterModule],
})
export class ResetPasswordRoutingModule {}
